var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "container" },
    [
      _c(
        "md-layout",
        { attrs: { "md-column": "md-column", "md-flex": "40" } },
        [
          _vm.videos.length > 0
            ? _c(
                "md-theme",
                { staticClass: "table", attrs: { "md-name": "blue" } },
                [
                  _vm.rowsHidden
                    ? _c(
                        "md-card",
                        { staticClass: "md-table-card content-table hidden" },
                        [
                          _c("label", { staticClass: "align-center" }, [
                            _vm._v(
                              "Uploading " +
                                _vm._s(this.videos.length) +
                                " videos "
                            )
                          ]),
                          _c(
                            "md-button",
                            {
                              staticClass: "hide-show-table",
                              on: { click: _vm.hideShowRows }
                            },
                            [
                              _c("md-icon", {
                                attrs: {
                                  "md-iconset": "fa fa-arrow-circle-down"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    : _c(
                        "md-card",
                        { staticClass: "content-table" },
                        [
                          _c(
                            "div",
                            { staticClass: "titleLine styleRow" },
                            [
                              _c("p", { staticClass: "rowElements" }, [
                                _vm._v("Name")
                              ]),
                              _c("p", { staticClass: "rowElements" }, [
                                _vm._v("Status")
                              ]),
                              _c("p", { staticClass: "rowElements" }, [
                                _vm._v("Progress")
                              ]),
                              _c(
                                "md-button",
                                {
                                  staticClass: "hide-show-table",
                                  on: { click: _vm.hideShowRows }
                                },
                                [
                                  _c("md-icon", {
                                    attrs: {
                                      "md-iconset": "fa fa-arrow-circle-up"
                                    }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _vm._l(_vm.videos, function(video) {
                            return _c(
                              "div",
                              {
                                key: video.name,
                                staticClass: "styleRow",
                                attrs: { id: "rowVideos" }
                              },
                              [
                                _c("div", { staticClass: "rowElements" }, [
                                  _vm._v(_vm._s(_vm.getShortName(video.name)))
                                ]),
                                video.progress === "100"
                                  ? _c("div", { staticClass: "rowElements" }, [
                                      _vm._v("completed")
                                    ])
                                  : _c("div", { staticClass: "rowElements" }, [
                                      _vm._v(_vm._s(video.status))
                                    ]),
                                _c("div", { staticClass: "rowElements" }, [
                                  _vm._v(
                                    " " +
                                      _vm._s(video.progress) +
                                      " " +
                                      _vm._s(
                                        video.progress !== "errored" ? "%" : ""
                                      )
                                  )
                                ]),
                                _c(
                                  "md-button",
                                  _vm._g(
                                    {
                                      staticClass:
                                        "md-icon-button md-raised icon-center"
                                    },
                                    video.progress === "errored" ||
                                      video.progress === "100"
                                      ? {
                                          click: function() {
                                            return _vm.deleteVideo(video.name)
                                          }
                                        }
                                      : {}
                                  ),
                                  [
                                    _c("md-icon", {
                                      attrs: {
                                        "md-iconset":
                                          video.progress === "100"
                                            ? "fa fa-check"
                                            : video.progress === "errored"
                                            ? "fa fa-trash-alt"
                                            : "fa fa-spinner fa-spin "
                                      }
                                    })
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          })
                        ],
                        2
                      )
                ],
                1
              )
            : _vm._e()
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-1e755ee6", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1e755ee6","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug&optionsId=0!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/spa/mediaItem/MediaItemUploading.vue
// module id = 631
// module chunks = 0